import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet, apiPost } from "../utils/api_service";
const initialState = {
  weeklyOff: [],
};
let URL = endpoints.weeklyOff;
let URL1 = endpoints.weeklyOfUserWise;
const weeklyOffSlice = createSlice({
  name: "weeklyOff",
  initialState,
  reducers: {
    weeklyOffSuccess: (state = cloneDeep(initialState), action) => {
      const { row } = action.payload;
      return {
        ...state,
        weeklyOff: row,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { weeklyOffSuccess, resetState } = weeklyOffSlice.actions;

export default weeklyOffSlice.reducer;

export const getWeeklyOff = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL,
    }).then(({ data, success }) => {
      if (success) {
        const { content } = data.data;
        const row = content.map((yearObject, index) => {
          let yearData = {
            index: index + 1,
            id: yearObject.id === null ? "" : yearObject.id,
            day: yearObject.day === null ? "" : yearObject.day,
            dayName:
              yearObject.day === null
                ? ""
                : yearObject.day == 0
                ? "Monday"
                : yearObject.day == 1
                ? "Tuesday"
                : yearObject.day == 2
                ? "Wednesday"
                : yearObject.day == 3
                ? "Thursday"
                : yearObject.day == 4
                ? "Friday"
                : yearObject.day == 5
                ? "Saturday"
                : "Sunday",
            isActive: yearObject.isActive === null ? "" : yearObject.isActive,
          };
          return yearData;
        });
        dispatch(weeklyOffSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};

export const getWeeklyOffUserWise =
  ({ dataJson }) =>
  async (dispatch) => {
    try {
      const response = apiPost({
        url: URL1 + "/sales-team-configuration",
        postBody: dataJson,
      }).then(({ data, success }) => {
        if (success) {
          const row = data.data.map((salesObject, index) => {
            let salesData = {
              index: index + 1,
              id: salesObject.id === null ? "" : salesObject.id,
              userName:
                salesObject.userName === null ? "" : salesObject.userName,
              designation:
                salesObject.stockStakeHolderType !== null &&
                salesObject.stockStakeHolderType.name !== null
                  ? salesObject.stockStakeHolderType.name
                  : "",
              name: salesObject.name === null ? "" : salesObject.name,
              employeeCode:
                salesObject.employeeCode === null
                  ? ""
                  : salesObject.employeeCode,

              days: Array.isArray(salesObject.days)
                ? salesObject.days
                : salesObject.days !== null
                ? [salesObject.days]
                : [],

              isActive:
                salesObject.isActive === null ? "" : salesObject.isActive,
            };
            return salesData;
          });
          dispatch(weeklyOffSuccess({ row }));
          return { response: row, success };
        }
        return { response: [], success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };

export const getAllWeeklyOffUserWise = () => async (dispatch) => {
  try {
    const response = apiGet({
      url: URL1 + "/get-all",
    }).then(({ data, success }) => {
      if (success) {
        const row = data.data.map((userObj, index) => {
          let yearData = {
            index: index + 1,
            id: userObj.salesTeamId === null ? "" : userObj.salesTeamId,
            employeeCode:
              userObj.employeeCode === null ? "" : userObj.employeeCode,
            name: userObj.salesTeamName === null ? "" : userObj.salesTeamName,
            designation:
              userObj.designation === null ? "" : userObj.designation,
            dayName:
              userObj.days === null || userObj.days === ""
                ? ""
                : userObj.days
                    .split(",")
                    .map((d) =>
                      d == 0
                        ? "Monday"
                        : d == 1
                        ? "Tuesday"
                        : d == 2
                        ? "Wednesday"
                        : d == 3
                        ? "Thursday"
                        : d == 4
                        ? "Friday"
                        : d == 5
                        ? "Saturday"
                        : "Sunday"
                    )
                    .join(", "),
          };
          return yearData;
        });
        dispatch(weeklyOffSuccess({ row }));
        return { response: row, success };
      }
      return { response: [], success };
    });
    return response;
  } catch (e) {
    return console.error(e.message);
  }
};
